import * as actions from './actions';
import * as components from './components';
import * as constants from './constants';
import reducer from './reducer';
import * as selectors from './selectors';
import sagas from './sagas';

export default { actions, components, reducer, selectors, constants, sagas };